import { HTMLAttributes } from 'react'

export function SVGRocketlab() {
  return (
    <svg width="90" height="12" viewBox="0 0 90 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.874 11.9882L74.6356 0L80.3971 11.9882H73.0151H68.874Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13867 5.92674C9.13867 5.10986 9.29323 4.40726 9.60237 3.66765C9.9115 2.92805 10.3264 2.29056 10.847 1.75518C11.3677 1.21979 11.99 0.793418 12.714 0.47605C13.438 0.158682 14.1746 0 14.9664 0C16.0348 0 17.0405 0.267689 17.9407 0.803075C18.841 1.33846 19.5515 2.06702 20.0721 2.98877C20.5927 3.91051 20.8531 4.83941 20.8531 5.92674C20.8531 7.00855 20.5927 8.08318 20.0721 8.99941C19.5515 9.91564 18.841 10.6428 17.9407 11.181C17.0405 11.7191 16.0348 11.9882 14.9664 11.9882C14.1746 11.9882 13.438 11.8295 12.714 11.5121C11.99 11.1948 11.3677 10.7684 10.847 10.233C10.3264 9.69762 9.9115 9.06013 9.60237 8.32052C9.29323 7.58092 9.13867 6.73258 9.13867 5.92674Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.9882V5.92674V0H4.60141C5.251 0 5.83291 0.113282 6.34717 0.339849C6.86143 0.566416 7.27418 0.870861 7.58545 1.25319C7.89671 1.63553 8.13218 2.06033 8.29187 2.52763C8.45156 2.99492 8.53141 3.48628 8.53141 4.00172C8.53141 4.90799 8.29593 5.71796 7.82498 6.43164C7.35403 7.14533 6.44521 7.58029 5.55744 7.81252L9.4039 11.9882H5.5707H0ZM0 5.92674V11.9882H5.56287L0 5.92674Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.0591 11.9882V0H85.8227C86.9014 0 87.7655 0.294533 88.415 0.883608C89.0645 1.47268 89.3892 2.2515 89.3892 3.22007C89.3892 3.41265 89.3631 3.61514 89.3108 3.82755C89.2585 4.03996 89.1759 4.2651 89.0631 4.503C88.9503 4.7409 88.781 4.95755 88.5554 5.15296C88.3297 5.34838 87.9303 5.49139 87.6221 5.58202C87.9303 5.62733 88.3448 5.72079 88.6008 5.8624C88.8567 6.004 89.0686 6.17109 89.2365 6.36367C89.4043 6.55626 89.5474 6.77149 89.6658 7.00939C89.7841 7.24728 89.8694 7.48518 89.9217 7.72307C89.974 7.96097 90.0001 8.19886 90.0001 8.43675C90.0001 8.89555 89.9313 9.32744 89.7937 9.73243C89.6561 10.1374 89.4429 10.5127 89.1539 10.8582C88.8649 11.2037 88.4645 11.4784 87.9527 11.6823C87.4408 11.8862 86.8437 11.9882 86.1612 11.9882H81.0591Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5889 6.00237C21.5889 5.18549 21.7434 4.40726 22.0526 3.66765C22.3617 2.92805 22.7766 2.29056 23.2972 1.75518C23.8179 1.21979 24.4402 0.793418 25.1642 0.47605C25.8882 0.158682 26.6461 0 27.4379 0C28.4467 0 29.3808 0.241472 30.2404 0.724424C31.1 1.20738 31.7983 1.86004 32.3352 2.68244L30.0167 4.32998C29.7401 3.88291 29.3741 3.52553 28.9185 3.25784C28.4629 2.99014 27.9694 2.8563 27.4379 2.8563C26.5919 2.8563 25.8747 3.16124 25.2862 3.77114C24.6978 4.38104 24.4036 5.12478 24.4036 6.00237C24.4036 6.87444 24.6964 7.61542 25.2822 8.22532C25.8679 8.83521 26.5865 9.14016 27.4379 9.14016C27.9748 9.14016 28.4711 9.00907 28.9266 8.7469C29.3822 8.48473 29.751 8.13011 30.033 7.68303L32.3189 9.31402C31.782 10.1364 31.0865 10.7877 30.2323 11.2679C29.3781 11.7481 28.4467 11.9882 27.4379 11.9882C26.6461 11.9882 25.8882 11.8295 25.1642 11.5121C24.4402 11.1948 23.8179 10.7684 23.2972 10.233C22.7766 9.69762 22.3617 9.06013 22.0526 8.32053C21.7434 7.58092 21.5889 6.80821 21.5889 6.00237ZM32.9795 12V0H35.8374V3.42736L38.9129 0H42.7808L37.3249 5.91921L42.7808 12H38.9129L35.8374 8.34302V12H32.9795ZM43.3106 11.9882V0H50.9328V2.54037H46.1595V4.83435H50.358V7.32375H46.1595V9.44781H51.0911V11.9882H43.3106ZM51.5224 2.54037V0H60.4635V2.54037H57.4247V11.9882H54.5695V2.54037H51.5224ZM61.0588 11.9882V0H63.9473V9.44781H68.1882V11.9882H61.0588Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.35156L3.31123 11.9884H0V8.35156Z"
        fill="white"
      />
    </svg>
  )
}

export function SVGInstagram() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_625_41189)">
        <path
          d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M21.5 4.5H10.5C7.18629 4.5 4.5 7.18629 4.5 10.5V21.5C4.5 24.8137 7.18629 27.5 10.5 27.5H21.5C24.8137 27.5 27.5 24.8137 27.5 21.5V10.5C27.5 7.18629 24.8137 4.5 21.5 4.5Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 11C23.3284 11 24 10.3284 24 9.5C24 8.67157 23.3284 8 22.5 8C21.6716 8 21 8.67157 21 9.5C21 10.3284 21.6716 11 22.5 11Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_625_41189">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SVGLinkedin() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_625_41195)">
        <path
          d="M26 5H6C5.44772 5 5 5.44772 5 6V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V6C27 5.44772 26.5523 5 26 5Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 14V22"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 14V22"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 17.5C15 16.5717 15.3687 15.6815 16.0251 15.0251C16.6815 14.3687 17.5717 14 18.5 14C19.4283 14 20.3185 14.3687 20.9749 15.0251C21.6313 15.6815 22 16.5717 22 17.5V22"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 11.5C11.8284 11.5 12.5 10.8284 12.5 10C12.5 9.17157 11.8284 8.5 11 8.5C10.1716 8.5 9.5 9.17157 9.5 10C9.5 10.8284 10.1716 11.5 11 11.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_625_41195">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SVGFacebook() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_625_41203)">
        <path
          d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 11H19C18.2044 11 17.4413 11.3161 16.8787 11.8787C16.3161 12.4413 16 13.2044 16 14V28"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18H20"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_625_41203">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SVGNewsletterImage(props: HTMLAttributes<SVGSVGElement>) {
  return (
    <svg
      width={302}
      height={359}
      viewBox="0 0 302 359"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M209.014 59.3876C209.886 51.7891 213.331 44.7152 218.781 39.3356C224.23 33.956 231.357 30.593 238.983 29.8029C243.99 29.2807 249.043 30.1594 253.578 32.3404C260.758 35.8505 283.867 46.6256 286.38 55.3731C288.54 63.1859 286.38 72.6799 275.97 85.3715C265.561 98.0631 270.879 139.1 270.879 139.1C270.967 141.44 270.563 143.771 269.695 145.946C262.587 162.64 231.223 160.965 227.292 141.462L227.737 107.558C207.59 101.859 206.855 76.894 209.014 59.3876Z"
        fill="#FCD2BF"
      />
      <path
        d="M227.744 107.557C227.744 107.557 237.111 110.911 250.244 102.289C245.326 111.527 237.295 118.734 227.568 122.64L227.744 107.557Z"
        fill="#FCD2BF"
      />
      <path
        d="M212.007 59.5976C212.007 59.5976 211.497 66.485 216.028 66.272C220.259 66.0732 219.563 58.4336 219.563 58.4336"
        stroke="#231F20"
        strokeWidth="0.9"
        strokeMiterlimit="10"
      />
      <path
        d="M237.422 57.4324C237.422 57.4324 237.911 65.364 243.289 64.3111C247.985 62.9374 248.856 55.6421 248.856 55.6421"
        stroke="#231F20"
        strokeWidth="0.9"
        strokeMiterlimit="10"
      />
      <path
        d="M222.915 82.56C222.915 82.56 228.791 87.8662 235.512 85.2364C242.221 82.6202 243.575 78.8447 243.575 78.8447"
        stroke="#231F20"
        strokeWidth="0.9"
        strokeMiterlimit="10"
      />
      <path
        d="M228.919 58.3652C228.919 58.3652 227.042 71.8218 226.565 72.6973C226.073 73.5666 232.094 74.823 232.094 74.823"
        stroke="#231F20"
        strokeWidth="0.9"
        strokeMiterlimit="10"
      />
      <path
        d="M256.714 42.9642C250.818 47.939 231.315 54.7228 206.369 50.6525C206.369 50.6525 209.348 7.13092 261.353 20.9978C261.353 20.9978 260.304 11.4878 264.735 5.99594C269.03 0.668865 283.345 -2.6903 292.65 2.83814C302.876 8.91576 302.69 22.0412 298.993 28.5033C295.297 34.9653 285.031 38.0499 285.031 38.0499C285.031 38.0499 298.993 70.5517 273.042 90.4509C273.042 90.4509 269.414 83.6671 273.949 75.9788C277.369 70.182 280.753 64.6724 278.031 59.2454C273.949 54.2706 265.746 61.9589 261.353 58.3409C259.598 56.6201 257.567 53.9955 256.714 52.0093C254.792 47.4511 256.714 42.9642 256.714 42.9642Z"
        fill="#231F20"
      />
      <path
        d="M248.736 105.447C240.745 110.064 231.388 108.77 227.708 107.546V119.087C242.428 119.927 247.86 110.344 248.736 105.447Z"
        fill="#E7B8A3"
      />
      <path
        d="M269.313 167.406C256.275 167.985 242.577 167.233 229.307 167.876C229.364 191.858 231.078 214.235 231.078 214.235C221.539 214.816 212.012 212.918 203.432 208.727C191.163 201.938 148.787 189.202 148.787 189.202C111.978 173.802 102.435 195.096 102.435 195.096C102.435 195.096 215.276 269.582 248.769 268.423C277.141 267.442 276.059 204.384 271.29 167.312C270.631 167.342 269.972 167.377 269.313 167.406Z"
        fill="#D3B0D3"
      />
      <path
        d="M112.918 169.367L109.285 217.792C109.285 217.792 200.065 268.476 199.694 268.437C199.324 268.397 217.866 205.234 217.866 205.234L112.918 169.367Z"
        fill="#E5DC74"
      />
      <path
        d="M88.3124 87.0264L175.563 100.364L120.301 286.495L0 268.239L58.0479 87.0264H88.3124Z"
        fill="white"
      />
      <path
        d="M148.217 125.328C147.209 125.701 146.127 125.834 145.058 125.717C142.145 125.691 139.253 125.223 136.482 124.33C134.558 123.717 132.699 122.92 130.929 121.949C129.1 120.807 127.117 119.927 125.041 119.337C122.686 118.978 120.29 118.983 117.937 119.353C115.221 119.624 112.489 119.695 109.763 119.568C104.174 119.292 98.9711 118.435 94.2713 117.81C90.1447 117.178 85.9781 116.841 81.8032 116.8C77.9658 116.998 74.1481 117.476 70.3807 118.229C70.3243 118.095 71.3136 117.555 73.2267 116.81C75.9823 115.902 78.8453 115.356 81.7429 115.187C86.0121 114.993 90.2901 115.172 94.5278 115.723C99.2887 116.24 104.459 117.022 109.867 117.287C112.489 117.411 115.116 117.357 117.731 117.126C120.316 116.759 122.945 116.814 125.513 117.287C127.771 117.968 129.912 118.984 131.864 120.302C133.505 121.285 135.229 122.123 137.017 122.806C140.668 123.976 144.416 124.82 148.217 125.328Z"
        fill="black"
      />
      <path
        d="M142.511 145.776C142.462 145.93 141.386 145.727 139.48 145.292C136.839 144.628 134.15 144.175 131.437 143.938C129.614 143.805 127.782 143.929 125.993 144.304C123.936 144.852 121.942 145.609 120.041 146.564C115.171 148.572 109.806 149.066 104.649 147.98C99.6887 146.957 94.7964 145.63 90.0003 144.006C86.1602 142.787 82.1927 142.01 78.1752 141.69C74.4689 141.58 70.7715 142.111 67.2476 143.26C70.3677 140.855 74.2875 139.717 78.2165 140.077C82.4013 140.17 86.5556 140.81 90.5729 141.981C95.0908 143.2 99.8825 144.848 105.033 145.73C109.772 146.745 114.706 146.36 119.229 144.623C121.272 143.664 123.416 142.935 125.621 142.448C127.592 142.112 129.602 142.072 131.585 142.33C134.376 142.713 137.112 143.421 139.737 144.441C141.581 145.143 142.558 145.629 142.511 145.776Z"
        fill="black"
      />
      <path
        d="M133.465 182.177C133.354 182.335 132.496 181.774 130.81 181.263C128.384 180.635 125.86 180.472 123.373 180.782C119.538 181.318 115.667 181.558 111.795 181.499C107.025 181.108 102.327 180.093 97.8232 178.48C89.9897 175.282 81.9347 172.652 73.7209 170.609C70.2649 170.17 66.7884 169.909 63.3053 169.827C63.2769 169.672 64.2557 169.403 66.0889 169.047C68.6998 168.694 71.346 168.682 73.9599 169.013C80.659 169.653 89.2352 173.089 98.5475 176.315C102.877 177.866 107.376 178.902 111.949 179.402C115.732 179.545 119.52 179.467 123.294 179.17C125.968 178.988 128.648 179.42 131.128 180.433C132.855 181.258 133.543 182.087 133.465 182.177Z"
        fill="black"
      />
      <path
        d="M68.9556 249.516C68.8932 250.143 59.9993 249.778 49.0934 248.7C38.1833 247.622 29.393 246.24 29.4554 245.612C29.5178 244.985 38.4097 245.35 49.3194 246.429C60.2256 247.507 69.018 248.889 68.9556 249.516Z"
        fill="black"
      />
      <path
        d="M77.5098 228.62C77.3224 229.249 68.9796 227.252 58.5931 225.456C48.2091 223.626 39.6837 222.678 39.7223 222.022C39.7461 221.418 48.4502 221.352 58.9888 223.208C69.5295 225.032 77.6938 228.044 77.5098 228.62Z"
        fill="black"
      />
      <path
        d="M42.1937 139.747C44.7464 140.916 47.6216 141.187 50.3493 140.517C50.7001 140.431 51.0164 140.241 51.2561 139.972C51.4958 139.703 51.6475 139.367 51.6911 139.01C51.7346 138.653 51.668 138.291 51.5 137.973C51.3319 137.654 51.0705 137.394 50.7505 137.228C47.2937 135.393 42.0069 133.366 39.3505 136.247C37.7462 137.987 37.8657 139.037 36.0619 142.031C35.2717 143.343 36.0619 150.331 38.4671 144.941C39.0908 143.543 36.418 145.445 34.8662 147.255C34.4701 147.613 34.1698 148.064 33.9927 148.567C33.8156 149.07 33.7671 149.609 33.8516 150.135C33.9362 150.661 34.1512 151.158 34.4771 151.581C34.803 152.004 35.2295 152.339 35.7182 152.556C36.0619 148.449 32.0308 153.478 32.5396 155.465C32.9591 157.102 34.22 159.042 35.9154 159.069C38.7738 158.899 41.5727 158.183 44.1593 156.959C48.5764 154.605 40.5767 150.866 39.8552 153.403C41.3527 153.674 42.8983 153.415 44.2246 152.671C45.5508 151.928 46.5745 150.745 47.1185 149.33C47.278 146.634 42.7239 146.758 41.6491 146.585C43.7314 146.393 49.4269 146.571 49.8099 144.523C50.193 142.475 42.2189 137.361 40.895 138.974"
        fill="#FCD2BF"
      />
      <path
        d="M247.085 132.395L222.123 124.682L187.513 219.742C183.581 230.539 180.698 241.687 178.902 253.033L165.55 333.761H293.454C293.454 333.761 290.271 207.595 279.498 140.874L247.085 132.395Z"
        fill="#FFF68D"
      />
      <path
        d="M222.115 124.672L275.835 120.647L279.487 140.865L229.916 144.122L222.115 124.672Z"
        fill="#FFF68D"
      />
      <path
        d="M39.8824 200.801C39.1875 197.955 50.1049 207.973 50.1049 207.973C50.1049 207.973 41.6042 196.511 40.7704 192.065C40.1042 188.524 54.0664 201.646 54.0664 201.646C43.7762 183.038 43.5078 184.15 43.7762 183.038C44.4694 180.154 59.5007 199.344 59.5007 199.344C59.5007 199.344 51.0378 185.742 52.551 183.265C54.0657 180.788 72.9512 204.856 72.9512 204.856C73.1988 200.561 75.0978 196.526 78.2538 193.59C78.9188 193.171 79.7001 192.973 80.4854 193.024C81.2707 193.075 82.0194 193.373 82.6239 193.875C78.1991 201.113 84.6852 220.704 84.6852 220.704C84.6894 220.708 118.773 268.915 164.829 293.782C172.777 280.921 179.738 267.481 185.653 253.575C194.774 232.578 202.414 210.973 208.516 188.917C219.315 150.859 234.712 151.867 234.712 151.867C259.629 141.548 265.644 164.343 265.736 188.326C265.657 212.764 259.962 236.859 249.085 258.765C216.291 325.933 188.098 349.427 176.851 348.658C171.408 350.032 124.917 342.001 70.7749 245.559L64.912 233.931C64.912 233.931 40.5763 203.647 39.8824 200.801Z"
        fill="#FCD2BF"
      />
      <path
        d="M98.381 237.825L77.5063 272.229C77.5063 272.229 131.082 355.632 175.559 358.134C220.036 360.636 266.072 271.82 272.787 206.341C272.787 206.341 275.316 148.927 241.544 147.868C235.255 147.805 229.104 149.708 223.957 153.308C218.809 156.908 214.925 162.025 212.849 167.939L169.279 286.49L98.381 237.825Z"
        fill="#FFF68D"
      />
    </svg>
  )
}
